<template>
    <div class="comboFind">
        <el-form  ref="form" label-width="45%" class="formMsg" v-if="formNew === '1'">
          <data-form :formItem="form"></data-form>
        </el-form>

      <div class="findBottom">
        <el-button type="warning" @click="cancel">返回重选</el-button>
        <el-button type="primary" @click="search">确认查询</el-button>
      </div>
    </div>
</template>

<script>
  import bus from './bus'
  import arrayData from '../assets/javascript/findData'
  import dataForm from '../assets/components/form'

    export default {
        name: "comboFind",
      components:{
          dataForm
      },
        data(){
            return {
              /*强制刷新组件*/
              formNew:'1',
              /*用户选择的项*/
              choose:[],
              /*渲染数组*/
              form:[

              ]
            }
        },
        methods:{
          /*传入用户选择的值*/
          getData(){
            for (let i = 0; i < this.choose.length; i++) {
              for(let j = 0;j < arrayData.length; j++){
                if(this.choose[i] === arrayData[j].name){
                  this.form.push(arrayData [j]);
                }
              }
            }
          },
          /*取消重选*/
          cancel(){
            bus.$emit('cancel');
            this.choose = [];
            this.form = [];
          },
          /*强制组件刷新*/
          componentNew(){
            this.formNew = '2';
            this.$nextTick(()=>{
              this.formNew = '1'
            });
          },
          /*查询函数*/
          search(){
            let postData = {};
            for (let i = 0; i < this.form.length; i++) {
                postData[this.form [i].name] = this.form [i].value;
            }
            //发送事件表示已经获取到数据
            bus.$emit('getResult',postData);
          }
        },
        created(){
            bus.$on('choose',msg=>{
              this.choose = msg;
              this.getData();
              this.componentNew();
            });
        }
    }
</script>

<style scoped>
  .comboFind{
    width: 100%;
    height: 100%;
  }
  .formMsg{
    margin-left: 2%;
    width: 98%;
    height: 90%;
    overflow-y: scroll;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content:flex-start;
  }
  .findBottom{
    margin-left: 70%;
    width: 20%;
    height: 10%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

</style>



// WEBPACK FOOTER //
// src/data/comboFind.vue